module.exports = __webpack_public_path__ + "0f66581.ttf";